var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recaptcha-policy grey--text"},[_vm._v("\n    This site is protected by reCAPTCHA and the Google\n    "),_c('a',{attrs:{"href":"https://policies.google.com/privacy"}},[_vm._v("Privacy Policy")]),_vm._v(" and\n    "),_c('a',{attrs:{"href":"https://policies.google.com/terms"}},[_vm._v("Terms of Service")]),_vm._v(" apply.\n  ")])
}]

export { render, staticRenderFns }